/* Morelove — Hug Timer
   Stopwatch del rituale (soglia 21s) + contatori "community" decorativi. */
(function () {
  'use strict';

  function init() {
    /* ---------- Cronometro principale ---------- */
    var digits = document.getElementById('timer-digits');
    var stateEl = document.getElementById('timer-state');
    var ring = document.getElementById('timer-ring-progress');
    var startBtn = document.getElementById('timer-start');
    var stopBtn = document.getElementById('timer-stop');
    var resetBtn = document.getElementById('timer-reset');

    if (digits && startBtn) {
      var THRESHOLD = 21;                 // secondi
      var CIRC = 603.18;                  // 2 * PI * r (r=96)
      var elapsed = 0;                    // secondi trascorsi
      var startTs = 0;                    // timestamp di avvio
      var raf = null;
      var reached = false;

      function pad(n) { return (n < 10 ? '0' : '') + n; }

      function render(sec) {
        var s = Math.floor(sec);
        var mm = Math.floor(s / 60);
        var ss = s % 60;
        digits.innerHTML = pad(mm) + '<em>:</em>' + pad(ss);
        if (ring) {
          var pct = Math.min(sec / THRESHOLD, 1);
          ring.setAttribute('stroke-dashoffset', String(CIRC * (1 - pct)));
        }
        if (sec >= THRESHOLD && !reached) {
          reached = true;
          if (stateEl) stateEl.textContent = 'Soglia raggiunta · il resto è bonus';
        }
      }

      function tick() {
        elapsed = (Date.now() - startTs) / 1000;
        render(elapsed);
        raf = requestAnimationFrame(tick);
      }

      function start() {
        if (raf) return;
        startTs = Date.now() - elapsed * 1000;
        if (stateEl && !reached) stateEl.textContent = 'In corso…';
        tick();
      }

      function stop() {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (stateEl && !reached) stateEl.textContent = 'In pausa';
      }

      function reset() {
        stop();
        elapsed = 0;
        reached = false;
        render(0);
        if (stateEl) stateEl.textContent = 'Pronto a iniziare';
      }

      startBtn.addEventListener('click', start);
      if (stopBtn) stopBtn.addEventListener('click', stop);
      if (resetBtn) resetBtn.addEventListener('click', reset);

      render(0);
    }

    /* ---------- Contatore globale "community" ----------
       Parte dal valore calcolato lato Liquid (identico a "The Hug Effect"
       in homepage) e prosegue live secondo per secondo. */
    var gDays = document.getElementById('ht-days');
    if (gDays) {
      var gHours = document.getElementById('ht-hours');
      var gMins = document.getElementById('ht-mins');
      var gSecs = document.getElementById('ht-secs');

      var live = document.querySelector('.ml-timer-live');
      var baseTotal = live ? parseInt(live.getAttribute('data-total-seconds'), 10) : 0;
      if (isNaN(baseTotal)) baseTotal = 0;
      var anchor = Date.now();                 // momento di apertura pagina
      function pad2(n) { return (n < 10 ? '0' : '') + n; }

      function tickGlobal() {
        var total = baseTotal + Math.floor((Date.now() - anchor) / 1000);
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        gDays.textContent = pad2(d);
        if (gHours) gHours.textContent = pad2(h);
        if (gMins) gMins.textContent = pad2(m);
        if (gSecs) gSecs.textContent = pad2(s);
      }
      tickGlobal();
      setInterval(tickGlobal, 1000);
    }

    /* ---------- "Persone che si stanno abbracciando ora" (decorativo) ---------- */
    var active = document.getElementById('ht-active');
    if (active) {
      var val = 40 + Math.floor(Math.random() * 30);
      function tickActive() {
        val += Math.floor(Math.random() * 7) - 3;     // drift ±3
        if (val < 12) val = 12;
        if (val > 120) val = 120;
        active.textContent = val;
      }
      tickActive();
      setInterval(tickActive, 4000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();